import React, { Fragment, useCallback, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { TYPE, URL } from "../../../constant";
import HACKLE_DATA from "../../../constant/HACKLE_DATA";
import { useAlert, useAmplitude, useUserInfo } from "../../../hooks";
import useHackleInfo from "../../../hooks/useHackle";
import { appsflyer, appsflyerEventName } from "../../../utils/appsflyer";
import { handlePayment } from "../../../utils/utilityEtc";

const Before = () => {
  const [Alert] = useAlert();
  const history = useHistory();
  const { setAmplitudeLog } = useAmplitude();
  const { info } = useUserInfo();
  const {
    t,
    i18n: { language },
  } = useTranslation();
  const { setHackleLog } = useHackleInfo();

  const handlePaymentBtn = useCallback(() => {
    handlePayment({ info, history, Alert, language });

    // 결제하기버튼클릭
    setAmplitudeLog({
      eventName: {
        name: "결제하기버튼클릭",
        event: {
          "소스화면": "",
          "상품 코드": info?.storeProductCode,
          "상품 명": info?.storeProductID,
        },
      },
    });
    setHackleLog(HACKLE_DATA.TYPE.PURCHASE_BTN_ONBOARDING_CLICK); // 결제 클릭
    appsflyer({
      eventName: appsflyerEventName.purchase_click,
      eventParams: null,
    });
  }, [info]);

  const setAmplitude = async () => {
    // 상품 구매화면 조회
    setAmplitudeLog({
      eventName: {
        name: "상품 구매화면 조회",
        event: {
          "소스화면": "",
          "상품 코드": info?.storeProductCode,
          "상품 명": info?.storeProductID,
        },
      },
    });
  };

  const setHackleEvent = () => {
    setHackleLog(HACKLE_DATA.TYPE.PURCHASE_PAGE_ONBOARDING_VIEW); // 화면 조회
  };

  useEffect(() => {
    setAmplitude();
    setHackleEvent();
  }, [info]);

  return (
    <div className={`payment ${info?.countryCd === TYPE.COUNTRY_CODE.KOREA ? 'before' : 'onAtr'}`}>
      <div className="layout-def layout-lc">
        {/* header */}
        <div className="header">
          <div className="inner">
            <div className="header_wrap">
              <h1 className="logo">
                <img
                  src={`${process.env.PUBLIC_URL}/static/images/payment/logo_mathpid.svg`}
                  alt="Mathpid premium"
                />
              </h1>
            </div>
          </div>
        </div>
        {/* container */}
        <div className="container">
          <div className="inner">
            <div className="centermiddleBox">
              <div className="centermiddleBox-row">
                <div className="cont_area">
                  {/* KR */}
                  {info?.countryCd === TYPE.COUNTRY_CODE.KOREA && (
                    <Fragment>
                      <h2
                        className="sub_tit"
                        dangerouslySetInnerHTML={{
                          __html: t("PAYMENT.BEFORE_POPUP.msg001"),
                        }}
                      />
                      {/* KR */}
                      {info?.storeProductID ===
                        TYPE.PAYMENT["KR"].PRODUCT_ID && (
                        <img
                          className="pay_sct"
                          src={`${process.env.PUBLIC_URL}/static/images/payment/txt_pay_${language}.svg`}
                          alt={t("PAYMENT.BEFORE_POPUP.msg002")}
                        />
                      )}
                      {/* IN, PH */}
                      {info?.storeProductID ===
                        TYPE.PAYMENT["IN"].PRODUCT_ID && (
                        <img
                          className="pay_sct"
                          src={`${process.env.PUBLIC_URL}/static/images/payment/txt_pay_${language}.svg`}
                          alt={t("PAYMENT.BEFORE_POPUP.msg002")}
                        />
                      )}
                      {/* KR */}
                      {info?.storeProductID === TYPE.PAYMENT["KR"].PRODUCT_ID &&
                        language === "ko" && (
                          <img
                            className="pay_sum"
                            src={`${process.env.PUBLIC_URL}/static/images/payment/txt_pay_sum_ko.png`}
                            alt="론칭기념 50% 월 15,000원"
                          />
                        )}
                      {info?.storeProductID === TYPE.PAYMENT["KR"].PRODUCT_ID &&
                        language === "en" && (
                          <React.Fragment>
                            <img
                              className="pay_sum"
                              src={`${process.env.PUBLIC_URL}/static/images/payment/txt_pay_sum_ko_sct.png`}
                              alt="50% OFF 15,000won"
                            />
                            <p className="perYear">
                              {t(
                                `PAYMENT.BEFORE_POPUP.msg003_${
                                  info?.storeProductID ===
                                  TYPE.PAYMENT["KR"].PRODUCT_ID
                                    ? "KR"
                                    : "IN"
                                }`
                              )}
                            </p>
                          </React.Fragment>
                        )}

                      {/* IN, PH */}
                      {info?.storeProductID ===
                        TYPE.PAYMENT["IN"].PRODUCT_ID && (
                        <React.Fragment>
                          <img
                            className="pay_sum"
                            src={`${process.env.PUBLIC_URL}/static/images/payment/txt_pay_sum.png`}
                            alt="80% OFF $3.99"
                          />
                          <p className="perYear">
                            {t(
                              `PAYMENT.BEFORE_POPUP.msg003_${
                                info?.storeProductID ===
                                TYPE.PAYMENT["KR"].PRODUCT_ID
                                  ? "KR"
                                  : "IN"
                              }`
                            )}
                          </p>
                        </React.Fragment>
                      )}

                      <div className="btn_pay">
                        <button
                          type="button"
                          className="btn btn-navy ko"
                          onClick={handlePaymentBtn}
                        >
                          {t("PAYMENT.BEFORE_POPUP.msg004")}
                        </button>
                        <button
                          type="button"
                          className="btn btn-under"
                          onClick={() => history.push(URL.SELECT_LEARNING, { prevPoint: "init_appLogin" })}
                        >
                          {t("PAYMENT.BEFORE_POPUP.msg005")}
                        </button>
                      </div>
                    </Fragment>
                  )}

                  {/* IN 또는 PH */}
                  {info?.countryCd !== TYPE.COUNTRY_CODE.KOREA && (
                    <div className="cont_area">
                      <div className="cont1">
                        {info?.countryCd === TYPE.COUNTRY_CODE.INDIA && (
                          <img
                            className="pay_sum"
                            src={`${process.env.PUBLIC_URL}/static/images/payment/img_pay_sum_in.png`}
                            alt="TIME-LIMIT Special Offer Only For You ₹309.99"
                          />
                        )}
                        {info?.countryCd === TYPE.COUNTRY_CODE.PHILIPPINES && (
                          <img
                            className="pay_sum"
                            src={`${process.env.PUBLIC_URL}/static/images/payment/img_pay_sum_ph.png`}
                            alt="TIME-LIMIT Special Offer Only For You ₹309.99"
                          />
                        )}
                        <h2 className="sub_tit">
                          Advanced personalized <br />
                          learning by AI Tutor
                        </h2>
                        <ul className="pay_dsc_lst">
                          <li>
                            <p className="chk_tit_txt">
                              Silicon Valley Based AI Diagnosis
                            </p>
                          </li>
                          <li>
                            <p className="chk_tit_txt">
                              Customized Learning Course
                            </p>
                          </li>
                          <li>
                            <p className="chk_tit_txt">UNLIMITED Problems!</p>
                          </li>
                          <li>
                            <p className="chk_tit_txt">
                              20+ Math games coming soon!
                            </p>
                          </li>
                          <li>
                            <p className="chk_tit_txt">
                              and much more to be updated!
                            </p>
                          </li>
                        </ul>
                      </div>
                      <div className="cont2">
                        <div className="cont2_tit_bg"></div>
                        <div className="cont2_tit">
                          <p className="blue">Limited vs Premium</p>
                          <p className="sblue">What’s the Difference?</p>
                        </div>
                        <div className="payBtn">
                          <button type="button" className="btn_lp">
                            Limited
                          </button>
                          <button type="button" className="btn_pr">
                            Premium
                          </button>
                        </div>
                        <img
                          className="pay_grade"
                          src={`${process.env.PUBLIC_URL}/static/images/payment/table_pay.svg`}
                          alt=""
                        />
                      </div>
                      <div className="btn_pay">
                        <button
                          type="button"
                          className="btn btn-navy"
                          onClick={handlePaymentBtn}
                        >
                          Start Premium Now!
                        </button>
                        <button
                          type="button"
                          className="btn btn-under"
                          onClick={() => history.push(URL.SELECT_LEARNING, { prevPoint: "init_appLogin" })}
                        >
                          Try it Free
                        </button>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Before;
